import logoAllu from "@/assets/logo-allu.png";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export default function Logo({ className = "", size = "md" }: LogoProps) {
  const sizes = {
    sm: { width: 80, height: 24 },
    md: { width: 100, height: 30 },
    lg: { width: 130, height: 40 },
  };

  const { width, height } = sizes[size];

  return (
    <img
      src={logoAllu}
      alt="allu.capital"
      width={width}
      height={height}
      className={className}
    />
  );
}
